<template>
  <div>
    <CTitle large>
      {{ $t('Budget Alerts') }}
    </CTitle>

    <BudgetAlertsHeadContents
      :loading="loadingBudgetAlerts"
      @openModal="openBudgetAlertModal('create', {})"
    />

    <AlertsTable
      :tableData="alerts"
      @openModal="openDeleteModal"
      @openEditModal="openBudgetAlertModal"
    />

    <BudgetAlertDialog
      v-model="budgetAlertDialogVisible"
      :mode="budgetAlertDialogMode"
      :initObject="budgetAlertDialogInitObject"
    />

    <DeleteAlertDialog v-model="deleteAlertDialogVisible" :id="toDeleteAlertId" />
  </div>
</template>

<script>
import BudgetAlertsHeadContents from './BudgetAlertsHeadContents.vue';
import BudgetAlertDialog from './BudgetAlertDialog.vue';
import DeleteAlertDialog from './DeleteAlertDialog.vue';
import AlertsTable from './AlertsTable.vue';
import CTitle from '@/components/uikit/CTitle/index.vue';

import { mapActions, mapGetters } from 'vuex';

const messages = {
  en: {
    'Budget Alerts': 'Budget Alerts',
  },
  ja: {
    'Budget Alerts': '予算アラート',
  },
};
export default {
  name: 'BudgetAlerts',
  components: {
    BudgetAlertsHeadContents,
    BudgetAlertDialog,
    AlertsTable,
    DeleteAlertDialog,
    CTitle,
  },
  i18n: { messages },
  data() {
    return {
      loadingBudgetAlerts: false,
      budgetAlertDialogVisible: false,
      deleteAlertDialogVisible: false,
      toDeleteAlertId: '',
      budgetAlertDialogMode: 'create',
      budgetAlertDialogInitObject: {},
    };
  },
  computed: {
    ...mapGetters('notificationSettings', {
      alerts: 'alerts',
    }),
  },
  methods: {
    ...mapActions('notificationSettings', {
      fetchAlerts: 'fetchAlerts',
    }),
    ...mapActions('accounts', {
      fetchAccounts: 'fetchAccounts',
    }),
    async fetchBudgetAlertsData() {
      this.loadingBudgetAlerts = true;
      await Promise.all([this.fetchAlerts(), this.fetchAccounts({ force: true })]);
      this.loadingBudgetAlerts = false;
    },
    openDeleteModal(id) {
      this.toDeleteAlertId = id;
      this.deleteAlertDialogVisible = true;
    },
    openBudgetAlertModal(mode, initObject) {
      this.budgetAlertDialogMode = mode;
      this.budgetAlertDialogInitObject = initObject;
      this.budgetAlertDialogVisible = true;
    },
  },
};
</script>
